<template>
  <div class="main-table-all-back-wrap">
    <main-table-all-back
        v-if="tripsList"
        flag="tripList"
        textCreate="Add trip"
        pageTitle="Trips"
        :headers="headers"
        :headersChildren="headers"
        :filtersList="filtersTrips"
        :list="tripsList"
        :uniqId="uniqId"
        :totals="tripsTotals"
        :exportStart="exportStart"
        :exportList="exportList"
        :is-export="isExport()"
        :defaultOrder="tripsOrder"
        :defaultSort="tripsSort"
        :limitPages="tripsLimit"
        :totalPages="tripsTotal"
        :is-create="isCreate()"

        :pages="[ 10, 15, 20, 50, 100, 200, 500 ]"
        @updateRowsPerPage="onRowsPerPage"
        @updateSettings="onSettingsOpen"
        @updateEdit="onEdit"
        @updateChild="onChild"
        @updateExportList="onExportList"
        @updateCreate="onCreate"
        @updateClickButton="onClickButton"
        @updateList="onList"
        @updateRefreshFilters="onList"
        @updatePerLoad="onPerLoad"

        is-settings
    ></main-table-all-back>
<!--	  :preloaderTotals="preloaderTotalsTrips"-->
    <remove-block
        v-if="snackbar"
        @updateRemoveItem="onRemoveItem"
        @updateRemoveClose="onRemoveClose"
    ></remove-block>
    <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('trips')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>
    <preloader v-if="isFilterLoad" :preload="isFilterLoad"></preloader>

	  <dialog-trip
			  v-if="isDialogTrip"
			  :flag="flagDialogTrip"
			  @updateClosePopup="onClosePopup"
			  @updateRemoveTrip="onRemoveTrip"
	  ></dialog-trip>

	  <dialog-table
			  v-if="isTripItemFiles"
			  title="Trip Documents"
			  :list="tripItemFiles"
			  :headers="headerTripItemFiles"
			  flag="tripItemFiles"
			  @updateClose="onCloseDialogTable"
			  @updateClickButton="onClickButtonDialogTable"
	  ></dialog-table>

	  <preview-doc v-if="linkPreviewDoc" @clear-link="clearLinkPreviewDoc" :link-doc="linkPreviewDoc"></preview-doc>

	  <dialog-trip-view
			  v-if="isTripItemView"
			  :trip="tripItemView"
			  @updateTripInfo="onTripInfo"
			  @updateClose="onCloseDialogView"
	  />

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import DialogTrip from "@/components/Dispatch/Trips/DialogTrip/DialogTrip";
import TableSettings from "@/shared/TableSettings/TableSettings";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
import Preloader from "@/shared/Preload/Preload";
// helper
import { downloadDoc } from "@/helper/getDownloadDoc";
import settingsMixins from "@/mixins/settingsMixins";
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import DialogTable from "@/shared/DialogTable/DialogTable.vue";
import { getAppUrl } from "@/services";
import { tripItemFilesHeader } from "@/components/Dispatch/Trips/DialogTrip/constants";
import PreviewDoc from "@/modules/invoices/preview.vue";
import DialogTripView from "@/components/Dispatch/Trips/DialogTripView/DialogTripView.vue";

const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");

export default {
	name: "TripList",
	mixins: [ settingsMixins ],
	components: {
		DialogTripView,
		PreviewDoc,
		DialogTable,
		MainTableAllBack,
		RemoveBlock,
		TableSettings,
		Preloader,
		DialogTrip,
	},
	computed: {
		...mapGetters([
			"tripsList",
			"tripsTotal",
			"tripsTotals",
			"tripsOrder",
			"tripsSort",
			"tripsLimit",
			"filtersTrips",
			"exportLink",
			"preloaderTotalsTrips",
			"permissions",
			"permissionsDefault",

			"tripItemFiles",
			"tripItemView",
			"isLogin",
		]),
		headerTripItemFiles() {
			return tripItemFilesHeader;
		},
	},
	watch: {
		exportLink(value, oldValue) {
			if (value !== oldValue) {
				downloadDoc(value);
			}
		},
	},
	data: () => ({
		exportStart: { id: 0, value: "All loads files" },
		exportList: [
			{ id: 2, value: "BOL" },
			{ id: 1, value: "Confirmation" },
			{ id: 3, value: "Other" },
			{ id: 4, value: "Loads (xlsx)" },
			{ id: 5, value: "Trips (xlsx)" },
			{ id: 0, value: "All loads files" },
		],
		itemRemove: null,
		snackbar: false,
		filterModList: null,
		isFilterLoad: false,
		isDialogTrip: false,
		flagDialogTrip: null,
		isTripItemView: false,
		isTripItemFiles: false,
		linkPreviewDoc: null,
	}),
	methods: {
		...mapActions([
			"getListTrips",
			"getLoadsTrip",
			"getLoadsDelTrip",
			"getFiltersTrips",
			"getTotalTrips",
			"getExport",
			"getTripDelete",

			"getTripItemFiles",
			"getTripItemView",

			"doSettingsSetOptions",
			"doSettingsSave",
		]),
		async onRowsPerPage(value) {
			await this.doSettingsSetOptions({ limit: value });
			await this.doSettingsSave("trips");
		},
		onCloseDialogView() {
			this.isTripItemView = false;
		},
		onCloseDialogTable() {
			this.isTripItemFiles = false;
		},
		async onClickButtonDialogTable({ key, item }) {
			if (key === "view") {
				console.log('%c [  item  ] ', 'color:#bada55', typeof item, item );
				this.linkPreviewDoc = getAppUrl + item.file;
				// this.linkPreviewDoc = item.url;
			}
		},
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},
		isExport() {
			
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.DISPATCH, PERMISSIONS.TRIPS, PERMISSIONS.DOWNLOAD_DOC ];

			return getPermissionsMod({ list, path });
		},
		isCreate() {

			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.DISPATCH, PERMISSIONS.TRIPS, PERMISSIONS.CREATE_EDIT_TRIP ];

			return getPermissionsMod({ list, path });
		},
		checkRemove(item) {
			this.itemRemove = item;
			this.snackbar = true;
		},
		onRemoveClose() {
			this.snackbar = false;
		},
		onRemoveItem() {
			this.deleteAction();
			this.snackbar = false;
		},
		async deleteAction() {
			const { trip_id } = this.itemRemove;
			await this.getTripDelete(trip_id);
			await this.onList({ value: this.filterModList, flag: "delete" });
			this.snackbar = false;
			this.removeStart = true;
		},

		onPerLoad() {
			this.isFilterLoad = true;
		},
		async onList(arg) {
			const { value, flag } = arg;
			this.filterModList = value;
			switch (flag) {
				case "sorting":
					await this.getListTrips(value);
					this.isFilterLoad = false;
					break;
				default:
					await this.getListTrips(value);
					await this.getFiltersTrips(value);
					await this.getTotalTrips(value);
					this.isFilterLoad = false;
			}
		},
		async onTripInfo(id) {
			await this.getTripItemView(id);
		},
		async onClickButton({ key, item }) {
			if (key === "edit") {
				const { trip_id } = item;
				this.flagDialogTrip = trip_id;
				this.isDialogTrip = true;
			}
			if (key === "delete") {
				this.checkRemove(item);
			}
			if (key === "view") {
				const { trip_id } = item;
				await this.getTripItemView(trip_id);
				this.isTripItemView = true;
			}
			if (key === "download") {
				const { trip_id } = item;
				await this.getTripItemFiles(trip_id);
				this.isTripItemFiles = true;
			}
		},

		onEdit(value) {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.DISPATCH, PERMISSIONS.TRIPS, PERMISSIONS.CREATE_EDIT_TRIP ];

			const permEditMod = getPermissionsMod({ list, path });
			const { employee_id, role } = this.isLogin;

			if (!permEditMod) return;

			const { line } = value;
			const { trip_id, customer_invoice, dispatcher_id } = line;

			const isDispatcherRole = Number(role) === 1;
			const isSameEmployee = Number(employee_id) === Number(dispatcher_id);

			let canEdit = false;

			if (isDispatcherRole) {
				canEdit = isSameEmployee;
			} else {
				canEdit = true;
			}

			if (canEdit) {
				this.flagDialogTrip = trip_id;

				if (!customer_invoice) {
					this.isDialogTrip = true;
				}
			}
		},
		onRequestEdit(id) {
			const stateTrips = JSON.stringify(this.$store.getters.getFiltersVal);
			localStorage.setItem("state-trips", stateTrips);
			this.$router.push({ path: `${ id }` });
		},
		onCreate() {
			this.flagDialogTrip = 'new';
			this.isDialogTrip = true;
		},
		async onRemoveTrip(trip_id) {
			this.isDialogTrip = false;
			if (trip_id !== 'new') {
				await this.getTripDelete(trip_id);
				await this.onList({ value: this.filterModList, flag: "delete" });
				this.snackbar = false;
				this.removeStart = true;
			}
		},
		async onClosePopup(isSaveStatus) {
			this.isDialogTrip = false;
			if (isSaveStatus) {
				const value = this.filterModList;
				await this.getListTrips(value);
				await this.getFiltersTrips(value);
				await this.getTotalTrips(value);
				this.isFilterLoad = false;
			}

		},
		async onExportList(value) {
			await this.getExport(value);
		},
		async onChild(value) {
			const { line } = value;
			const { trip_id, children } = line;
			if (children.length) {
				await this.getLoadsDelTrip(trip_id);
			} else {
				await this.getLoadsTrip(trip_id);
			}
		},
	},
	async mounted() {
		await this.getListTrips();
		await this.getFiltersTrips();
		await this.getTotalTrips();
	},
};
</script>

<style lang="scss" scoped>
.main-table-all-back-wrap {
  height: 100%;
}
</style>
